export class HeaderConstants {
    static readonly deviceCode: string = '130355';
    static readonly scope: string = 'offline_access';
    static readonly clientId: string = 'Alive';
}